'use client';

import { datadogLogs } from '@datadog/browser-logs';
import { datadogRum } from '@datadog/browser-rum';
import { isObservabilityLogsEnabled } from './config';
import { extractHttpContext, redactString, scrubContext } from './scrub';

export type DegradedPath =
  /** 3DS não inicializou e o pagamento seguiu sem autenticação. */
  | 'three_ds_fallback'
  /** SDK de carteira digital não carregou e a opção foi escondida. */
  | 'digital_wallet_unavailable';

/**
 * Falha contornada, com o usuário seguindo o fluxo.
 *
 * Vai como `warn` nos Logs e `addAction` no RUM, e **sem `Error`** — é o `Error`
 * que faz o Error Tracking agrupar em issue. Sem essa separação, instabilidade de
 * terceiro infla a taxa de erro e treina o time a ignorar o alerta.
 */
export function reportDegradation(
  path: DegradedPath,
  cause?: unknown,
  meta: Record<string, unknown> = {}
): void {
  try {
    const context = {
      degraded_path: path,
      // Já resolve `http_duration_ms` a partir de `config.metadata`.
      ...extractHttpContext(cause),
      ...(cause instanceof Error
        ? { degradation_reason: redactString(cause.message) }
        : {}),
      ...(scrubContext(meta) as Record<string, unknown>),
    };

    if (typeof window === 'undefined') return;

    datadogRum.addAction('degraded_path', context);

    if (isObservabilityLogsEnabled()) {
      datadogLogs.logger.warn(`[degraded:${path}]`, context);
    }
  } catch {
    // Observabilidade não derruba checkout.
  }
}
